<div class="home-page">

  @if (userInfo$ | async; as student) {

    <!-- HERO / BIENVENIDA -->
    <section class="welcome-card">

      <div class="welcome-copy">
        <span class="eyebrow">Panel de estudiante</span>

        <h1>
          Bienvenido,
          <span>{{ student.fullName || student.mail }}</span>
        </h1>

        <p>
          Consulta tu información, actividades pendientes y progreso
          de servicio social desde un mismo lugar.
        </p>
      </div>

      <div class="welcome-badge">
        <div class="badge-initial">
          {{ (student.fullName || student.mail || '?').charAt(0) }}
        </div>

        <div class="badge-info">
          <strong>{{ student.fullName || 'Estudiante' }}</strong>
          <span>{{ student.schoolMail || student.mail }}</span>
        </div>
      </div>

    </section>


    <!-- RESUMEN RÁPIDO -->
    <section class="quick-stats">

      <div class="stat-card">
        <span class="stat-label">Carrera</span>
        <strong>{{ student.career || 'Sin registrar' }}</strong>
        <span class="stat-help">
          {{ student.school || 'Universidad registrada' }}
        </span>
      </div>
    
      <div class="stat-card">
        <span class="stat-label">Semestre</span>
        <strong>{{ student.semester || '1er Semestre' }}</strong>
        <span class="stat-help">Semestre actual</span>
      </div>
    
      <div class="stat-card">
        <span class="stat-label">Horas requeridas</span>
        <strong>{{ student.horasCubrir || 480 }}</strong>
        <span class="stat-help">Total por acreditar</span>
      </div>
    
      <div class="stat-card">
        <span class="stat-label">Horas acreditadas</span>
        <strong>{{ student.horasAcreditadas }}</strong>
        <span class="stat-help">Horas completadas</span>
      </div>
    
      <div class="stat-card">
        <span class="stat-label">Horas pendientes</span>
        <strong>{{ student.horasPendientes }}</strong>
        <span class="stat-help">Horas por completar</span>
      </div>
    
      <div class="stat-card">
        <span class="stat-label">Progreso</span>
        <strong>{{ progressPercentage | number:'1.0-0' }}%</strong>
        <span class="stat-help">Servicio social completado</span>
      </div>
    </section>


    <!-- INFORMACIÓN DEL ESTUDIANTE -->
    <section class="info-card">

      <div class="section-title">
        <div>
          <span class="section-kicker">Perfil</span>
          <h2>Información del estudiante</h2>
          <p>
            Datos registrados en tu perfil de servicio social.
          </p>
        </div>
      </div>

      <div class="student-name-block">
        <div class="student-avatar">
          {{ (student.fullName || student.mail || '?').charAt(0) }}
        </div>

        <div>
          <h3>{{ student.fullName || student.mail }}</h3>
          <span>{{ student.schoolMail || student.mail }}</span>
        </div>
      </div>

      <div class="student-grid">

        @for (field of displayFields; track field) {
          <div class="info-field">

            <span class="info-label">
              {{ field.label }}
            </span>

            <span class="info-value">
              {{ getNestedValue(student, field.key) || 'N/A' }}
            </span>

          </div>
        }

      </div>

    </section>


    <!-- PENDIENTES -->
<!-- ACTIVIDADES PENDIENTES -->
<section class="pending-card">

  <div class="section-title pending-title">
    <div>
      <span class="section-kicker">Seguimiento</span>
      <h2>Actividades pendientes</h2>
      <p>
        Actividades en las que estás registrado o que ya marcaste como asistidas.
      </p>
    </div>
  
    <div class="section-count">
      <strong>{{ pendingActivities.length }}</strong>
      <span>pendientes</span>
    </div>
  </div>

  <div class="pending-list">

    @for (activity of pendingActivities; track activity.activityRef) {

      <article class="pending-item">

        <div class="pending-icon">
          !
        </div>

        <div class="pending-main">

          <span class="pending-label">
            {{ activity.type }}
          </span>

          <h3>
            {{ activity.title }}
          </h3>

          <div
            class="activity-status"
            [class.status-registered]="activity.status === 'registered'"
            [class.status-attended]="activity.status === 'attended'"
          >
            @switch (activity.status) {
              @case ('registered') {
                Registrado
              }

              @case ('attended') {
                Asistió
              }
            }
          </div>

        </div>

        <div class="pending-meta">

          <div>
            <span>Fecha límite</span>
            <strong>
              {{ activity.dueDate | date:'mediumDate' }}
            </strong>
          </div>

          <div>
            <span>Valor</span>
            <strong>
              {{ activity.valueInHours }} h
            </strong>
          </div>

        </div>

      </article>

    } @empty {

      <div class="empty-pending">
        <strong>No tienes actividades pendientes</strong>
        <span>
          Cuando te registres a una actividad aparecerá aquí.
        </span>
      </div>

    }

  </div>

</section>


<!-- HISTORIAL DE ACTIVIDADES -->
<section class="pending-card history-card">

  <div class="section-title pending-title">
    <div>
      <span class="section-kicker">Historial</span>
      <h2>Historial de actividades</h2>
      <p>
        Actividades finalizadas o registradas como no asistidas.
      </p>
    </div>
  
    <div class="section-count">
      <strong>{{ activityHistory.length }}</strong>
      <span>registros</span>
    </div>
  </div>

  <div class="pending-list">

    @for (activity of activityHistory; track activity.activityRef) {

      <article class="pending-item">

       

        <div
          class="pending-icon"
          [class.history-validated]="activity.status === 'validated'"
          [class.history-absent]="activity.status === 'absent'"
        >
          @if (activity.status === 'validated') {
            ✓
          } @else {
            ✕
          }
        </div>

        <div class="pending-main">

          <span class="pending-label">
            {{ activity.type }}
          </span>

          <h3>
            {{ activity.title }}
          </h3>

          <div
            class="activity-status"
            [class.status-validated]="activity.status === 'validated'"
            [class.status-absent]="activity.status === 'absent'"
          >
            @switch (activity.status) {
              @case ('validated') {
                Horas validadas
              }

              @case ('absent') {
                No asistió
              }
            }
          </div>

        </div>

        <div class="pending-meta">

          <div>
            <span>Fecha</span>
            <strong>
              {{ activity.dueDate | date:'mediumDate' }}
            </strong>
          </div>
        
          <div>
            <span>Horas</span>
            <strong>
              @if (activity.status === 'validated') {
                {{ activity.validatedHours }} h
              } @else {
                0 h
              }
            </strong>
          </div>
        
          <div>
            <span>Desempeño</span>
            <strong>
              @switch (activity.status === 'absent' ? 'absent' : activity.performance) {
                @case ('very_bad') {
                  Muy malo
                }
                @case ('bad') {
                  Malo
                }
                @case ('good') {
                  Bueno
                }
                @case ('very_good') {
                  Muy bueno
                }
                @case ('excellent') {
                  Excelente
                }
                @case ('absent') {
                  Inasistencia
                }
                @default {
                  Pendiente de evaluación
                }
              }
            </strong>
          </div>
        
          <div>
            <span>Comentarios</span>
          
            <strong
              [class.comment-expanded]="
                expandedComments.has(activity.activityRef)
              "
            >
              {{ activity.performanceComment || 'Sin comentarios' }}
            </strong>
          
            @if (activity.performanceComment) {
              <button
                type="button"
                class="comment-toggle"
                (click)="toggleComment(activity.activityRef)"
              >
                {{
                  expandedComments.has(activity.activityRef)
                    ? 'Ocultar comentario'
                    : 'Ver comentario'
                }}
              </button>
            }
          </div>
        
        </div>

      </article>

    } @empty {

      <div class="empty-pending">
        <strong>Aún no tienes historial</strong>
        <span>
          Las actividades finalizadas aparecerán aquí.
        </span>
      </div>

    }

  </div>

</section>


    <!-- GRÁFICAS -->
    <div class="dashboard-charts">

      <div class="chart-card">
        <div class="chart-header">
          <h3>Progreso de servicio social</h3>
          <p>Horas acreditadas (azul) vs pendientes (naranja).</p>
        </div>

        <div class="chart-wrapper doughnut-wrapper">
          <canvas id="myChart"></canvas>
        </div>
      </div>


      <div class="chart-card">
        <div class="chart-header">
          <h3>Progreso en el tiempo</h3>
          <p>Acumulación cronológica de horas de servicio social.</p>
        </div>

        <div class="chart-wrapper">
          <canvas id="lineChart"></canvas>
        </div>
      </div>

    </div>

  } @else {

    <div class="loading-state">
      <div class="loading-dot"></div>
      <h3>Cargando información del estudiante...</h3>
    </div>

  }

</div>